export default "__VITE_ASSET__B48o6fcB__"